const isAllCase = (word: string, transform: (wordArg: string) => string) =>
  typeof word === 'string' && word.length > 0 && word === transform(word);
    
export const isAllUpperCase = (word: string) => isAllCase(word, s => s.toUpperCase());
export const isAllLowerCase = (word: string) => isAllCase(word, s => s.toLowerCase());
  